<div class="body ui container" fxLayout="column">
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="top"
      id="top"
    >
      <div>
        <span>Home</span>
        <h2 class="ui primary header">Create an Account</h2>
      </div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>

    <div
      *ngIf="!success"
      class="ui segment alert no-border"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <div fxFlex="5%">
        <i class="exclamation circle big colored primary icon"></i>
      </div>

      <div fxFlex>
        Please fill and submit the form below to complete your registration
      </div>
    </div>
    <div
      *ngIf="error"
      class="ui segment alert red no-border"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <div fxFlex="5%">
        <i class="exclamation circle big colored red icon"></i>
      </div>

      <div fxFlex>
        {{ error | json }}
      </div>
    </div>
    <div *ngIf="errorArray && errorArray?.length > 0">
      <div
        *ngFor="let s of errorArray"
        class="ui segment alert red no-border"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <div fxFlex="5%">
          <i class="exclamation circle big colored red icon"></i>
        </div>

        <div fxFlex>
          {{ s | json }}
        </div>
      </div>
    </div>

    <div
      *ngIf="success"
      class="ui segment alert no-border"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <div fxFlex="5%">
        <i class="exclamation circle big colored green icon"></i>
      </div>

      <div fxFlex>Your registration is successfully confirmed.</div>
    </div>

    <div class="ui segment light no-border" appPadding="10">
      <div fxLayout="row" appMargin marginB="10">
        <div fxFlex>
          <div class="sub-label">COMPANY RC/BN NUMBER</div>
          <div class="sub-vaue">
            {{
              userObject.rc_number
                ? userObject.rc_number
                : userObject.registrationNumber
            }}
          </div>
        </div>

        <div fxFlex>
          <div class="sub-value">
            {{
              userObject.cacRecord
                ? userObject?.cacRecord?.companyName
                : userObject.companyName
            }}
          </div>
          <div></div>
        </div>
        <div fxFlex></div>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <div class="sub-label">COMPANY OWNERSHIP TYPE</div>
          <div class="sub-value">{{ ownership?.optionName }}</div>
        </div>

        <div fxFlex>
          <div class="sub-label">COMPANY TYPE</div>
          <div class="sub-value">{{ company?.optionName }}</div>
        </div>

        <div fxFlex>
          <div class="sub-label">COMPANY TAX IDENTIFICATION NUMBER (TIN)</div>
          <div class="sub-value">{{ userObject.tin_number }}</div>
        </div>
      </div>
    </div>
    <form
      *ngIf="!success"
      class="ui form"
      appPadding="10"
      [formGroup]="detailForm"
    >
      <div class="ui box segment">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex id="primary">Company Address</div>
          <div>
            <button
              class="ui circular tiny button btn"
              (click)="companyAddress = !companyAddress"
            >
              <i
                [ngClass]="
                  companyAddress ? 'chevron up icon' : 'chevron down icon'
                "
              ></i>
            </button>
          </div>
        </div>
        <div [suiCollapse]="companyAddress">
          <div appPadding="10">
            <div class="two fields">
              <div
                class="required field"
                [ngClass]="displayFieldCss('countryOfRegistration')"
              >
                <label>Country</label>
                <select
                  class="myButton"
                  placeholder="Select Country"
                  formControlName="countryOfRegistration"
                  [disabled]="userObject.ownership_type === 'niegria_owned'"
                >
                  <option
                    *ngFor="let opt of countries"
                    [value]="opt.countryCode"
                  >
                    {{ opt.countryName }}
                  </option>
                </select>
                <app-field-error-display
                  [displayError]="isFieldValid('countryOfRegistration')"
                  errorMsg="Please select country"
                >
                </app-field-error-display>
              </div>
              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressPobox')"
              >
                <label>P.O.Box</label>
                <input
                  placeholder="P.O Box"
                  type="text"
                  formControlName="headOfficeAddressPobox"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressPobox')"
                  errorMsg="Please enter pobox"
                >
                </app-field-error-display>
              </div>
            </div>

            <div class="two fields">
              <div
                class="required field"
                [ngClass]="displayFieldCss('headOfficeAddressState')"
              >
                <label>State </label>
                <select
                  class="myButton"
                  placeholder="Select State"
                  type="text"
                  formControlName="headOfficeAddressState"
                >
                  <option *ngFor="let opt of states" [ngValue]="opt.stateId">
                    {{ opt.stateName }}
                  </option>
                </select>
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressState')"
                  errorMsg="Please select state "
                >
                </app-field-error-display>
              </div>
              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressZip')"
              >
                <label>Zip Code</label>
                <input
                  placeholder="Zip Code"
                  type="text"
                  formControlName="headOfficeAddressZip"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressZip')"
                  errorMsg="Please enter zip code"
                >
                </app-field-error-display>
              </div>
            </div>

            <div class="two fields">
              <div
                class="field required"
                [ngClass]="displayFieldCss('headOfficeAddressCity')"
              >
                <label>City:</label>
                <input
                  placeholder="City"
                  type="text"
                  formControlName="headOfficeAddressCity"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressCity')"
                  errorMsg="Please enter city"
                >
                </app-field-error-display>
              </div>
              <div
                class="field"
                [ngClass]="displayFieldCss('headOfficeAddressPmb')"
              >
                <label>PMB:</label>
                <input
                  placeholder="PMB"
                  type="text"
                  formControlName="headOfficeAddressPmb"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressPmb')"
                  errorMsg="Please enter company pmb"
                >
                </app-field-error-display>
              </div>
            </div>
            <div class="two fields">
              <div
                class="field required"
                [ngClass]="displayFieldCss('headOfficeAddressStreet')"
              >
                <label>Street:</label>
                <input
                  placeholder="Street"
                  type="text"
                  formControlName="headOfficeAddressStreet"
                />

                <app-field-error-display
                  [displayError]="isFieldValid('headOfficeAddressStreet')"
                  errorMsg="Please enter street"
                >
                </app-field-error-display>
              </div>
              <div
                class="field required"
                [ngClass]="displayFieldCss('dateOfRegistration')"
              >
                <label>Date of Registration (CAC):</label>
                <input
                  suiDatepicker
                  [pickerMode]="mode"
                  placeholder="Date of registration"
                  type="text"
                  formControlName="dateOfRegistration"
                />
                <app-field-error-display
                  [displayError]="isFieldValid('dateOfRegistration')"
                  errorMsg="Please enter date of registration"
                >
                </app-field-error-display>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui box segment">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex id="primary">Company Contact Information</div>
          <div>
            <button
              class="ui circular tiny button btn"
              (click)="mobileNumber = !mobileNumber"
            >
              <i
                [ngClass]="
                  mobileNumber ? 'chevron up icon' : 'chevron down icon'
                "
              ></i>
            </button>
          </div>
        </div>

        <div [suiCollapse]="mobileNumber">
          <div appPadding="10">
            <div class="two fields">
              <div
                class="field required"
                [ngClass]="displayFieldCss('companyContactPhone1')"
              >
                <label>Company Mobile Number:</label>
                <input
                  placeholder="Mobile Number"
                  type="text"
                  formControlName="companyContactPhone1"
                />

                <app-field-error-display
                  [displayError]="isFieldValid('companyContactPhone1')"
                  errorMsg="Please enter company phone number"
                >
                </app-field-error-display>
              </div>
              <div
                class="field"
                [ngClass]="displayFieldCss('companyContactPhone2')"
              >
                <label>Company Phone Number:</label>
                <input
                  placeholder="Phone Number"
                  type="text"
                  formControlName="companyContactPhone2"
                />

                <app-field-error-display
                  [displayError]="isFieldValid('companyContactPhone2')"
                  errorMsg="Please enter company phone number"
                >
                </app-field-error-display>
              </div>
            </div>
            <div class="two fields">
              <div
                class="field required"
                [ngClass]="displayFieldCss('companyContactEmail')"
              >
                <label>Company Email:</label>
                <input
                  placeholder="Email"
                  type="text"
                  formControlName="companyContactEmail"
                />
                <div
                  *ngIf="companyEmailLoading"
                  class="ui fluid red basic label"
                  style="margin: 0.3em 0"
                >
                  <div class="ui tiny active inline loader"></div>
                  checking company email availability
                </div>
                <div *ngIf="companyEmailServerError">
                  Oops! there seems to be a server error
                </div>
                <div
                  *ngIf="
                    detailForm.controls['companyContactEmail'].dirty &&
                    !detailForm.controls['companyContactEmail'].valid
                  "
                >
                  <div
                    *ngIf="
                      detailForm.controls['companyContactEmail'].errors?.email
                    "
                    class="ui pointing red basic label"
                  >
                    Invalid email
                  </div>
                  <div
                    *ngIf="
                      detailForm.controls['companyContactEmail'].errors(
                        'required'
                      )
                    "
                    class="ui pointing red basic label"
                  >
                    Please enter company email address
                  </div>
                </div>
                <div
                  class="ui pointing red basic label"
                  *ngIf="companyEmailError"
                >
                  Company Email already exist, please enter again.
                </div>
                <app-field-error-display
                  [displayError]="isFieldValid('companyContactEmail')"
                  errorMsg="Please enter company email"
                >
                </app-field-error-display>
              </div>
              <!-- <div
                class="field required"
                [ngClass]="displayFieldCss('appUserEmail')"
              >
                <label> Email:</label>
                <input
                  placeholder="Email"
                  type="text"
                  formControlName="appUserEmail"
                />
                <div
                  *ngIf="emailLoading"
                  class="ui fluid red basic label"
                  style="margin: 0.3em 0"
                >
                  <div class="ui tiny active inline loader"></div>
                  checking email availability
                </div>
                <div *ngIf="emailServerError">
                  Oops! there seems to be a server error
                </div>
                <div
                  *ngIf="
                    detailForm.controls['appUserEmail'].dirty &&
                    !detailForm.controls['appUserEmail'].valid
                  "
                >
                  <div
                    *ngIf="detailForm.controls['appUserEmail'].errors?.email"
                    class="ui pointing red basic label"
                  >
                    Invalid email
                  </div>
                  <div
                    *ngIf="detailForm.controls['appUserEmail'].errors?.required"
                    class="ui pointing red basic label"
                  >
                    Please enter your email address
                  </div>
                </div>
                <div class="ui pointing red basic label" *ngIf="emailError">
                  Email already exist, please enter again.
                </div>
              </div> -->
              <div class="field">
                <label>Company Alternative Email:</label>
                <input
                  placeholder="Alternative Email"
                  type="text"
                  formControlName="companyContactAlternativeEmail"
                />
              </div>
            </div>
            <div class="two fields">
              <div class="field">
                <label>Company Website:</label>
                <input
                  placeholder="Website"
                  type="text"
                  formControlName="website"
                />
              </div>
            </div>

            <!-- <div class="two fields">
							<div class=" required field">
							<label>Mobile Number </label>
							<input  type="text">
							</div>
							<div class=" field">
							<label>Office Phone</label>
							<input  type="text">
							</div>
						</div>

						<div class="two fields">
							<div class=" required field">
								<label>Email  </label>
								<input  type="text">
							</div>
							<div class="  field">
								<label>Website</label>
								<input  type="text">
							</div>
			  </div>  -->
          </div>
        </div>
      </div>

      <div class="ui box segment">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex id="primary">Login Information</div>
          <div>
            <button
              class="ui circular tiny button btn"
              (click)="loginInfo = !loginInfo"
            >
              <i
                [ngClass]="loginInfo ? 'chevron up icon' : 'chevron down icon'"
              ></i>
            </button>
          </div>
        </div>

        <div [suiCollapse]="loginInfo">
          <div appPadding="10">
            <!-- <form class="ui form" appPadding="10"> -->
            <div class="two fields">
              <div
                class="field required"
                [ngClass]="displayFieldCss('appUserEmail')"
              >
                <label> Email:</label>
                <input
                  placeholder="Email"
                  type="text"
                  formControlName="appUserEmail"
                />
                <div
                  *ngIf="emailLoading"
                  class="ui fluid red basic label"
                  style="margin: 0.3em 0"
                >
                  <div class="ui tiny active inline loader"></div>
                  checking email availability
                </div>
                <div *ngIf="emailServerError">
                  Oops! there seems to be a server error
                </div>
                <div
                  *ngIf="
                    detailForm.controls['appUserEmail'].dirty &&
                    !detailForm.controls['appUserEmail'].valid
                  "
                >
                  <div
                    *ngIf="detailForm.controls['appUserEmail'].errors?.email"
                    class="ui pointing red basic label"
                  >
                    Invalid email
                  </div>
                  <div
                    *ngIf="detailForm.controls['appUserEmail'].errors?.required"
                    class="ui pointing red basic label"
                  >
                    Please enter your email address
                  </div>
                </div>
                <div class="ui pointing red basic label" *ngIf="emailError">
                  Email already exist, please enter again.
                </div>
              </div>
              <div
                class="field required"
                [ngClass]="displayFieldCss('username')"
              >
                <label (click)="goTop()">Username :</label>
                <input
                  placeholder="username"
                  type="text"
                  formControlName="username"
                />
                <!-- <i *ngIf="usernameLoading" class="search icon"></i> -->
                <div
                  *ngIf="usernameLoading"
                  class="ui fluid red basic label"
                  style="margin: 0.3em 0"
                >
                  <div class="ui tiny active inline loader"></div>
                  checking username availability
                </div>
                <div
                  *ngIf="usernameServerError"
                  class="ui pointing red basic label"
                >
                  {{
                    username != null
                      ? "Oops! there seems to be a server error"
                      : "Please enter your username"
                  }}
                </div>

                <!-- <div *ngIf="detailForm.get('username').errors['usernameValidation']" class="ui pointing red basic label">
                        Username already exist, please enter again.
					</div> -->
                <div class="ui pointing red basic label" *ngIf="usernameError">
                  Username already exist, please enter again.
                </div>
              </div>
            </div>
            <div class="two fields">
              <div class="field required">
                <label>Password:</label>
                <input
                  placeholder="password"
                  type="password"
                  formControlName="password"
                />
                <div
                  *ngIf="
                    detailForm.get('password').dirty &&
                    detailForm.get('password').errors?.minlength
                  "
                  class="ui pointing red basic label"
                >
                  Password must be more than 6 characters
                </div>
                <app-field-error-display
                  [displayError]="isFieldValid('password')"
                  errorMsg="Please enter password"
                >
                </app-field-error-display>
              </div>
              <div class="field required">
                <label>Confirm Password:</label>
                <input
                  placeholder="password"
                  type="password"
                  formControlName="confirmPassword"
                />
                <div
                  *ngIf="
                    detailForm.controls['confirmPassword'].errors?.minlength
                  "
                  class="ui pointing red basic label"
                >
                  Password must be more than 6 characters
                </div>

                <div
                  *ngIf="
                    detailForm.controls['confirmPassword'].dirty &&
                    detailForm.errors &&
                    detailForm.errors?.matchingPasswords
                  "
                >
                  <div
                    *ngIf="detailForm.errors?.matchingPasswords"
                    class="ui pointing red basic label"
                  >
                    Passwords do not match
                  </div>
                </div>
                <app-field-error-display
                  [displayError]="isFieldValid('confirmPassword')"
                  errorMsg="Please enter confirm password"
                >
                </app-field-error-display>
              </div>
            </div>
            <div class="field required" [ngClass]="displayFieldCss('captcha')">
              <re-captcha
                #captchaRef="reCaptcha"
                formControlName="captcha"
              ></re-captcha>
              <app-field-error-display
                [displayError]="isFieldValid('captcha')"
                errorMsg="Please confirm you are not a robot"
              >
              </app-field-error-display>
            </div>
            <!-- </form> -->
            <!-- <re-captcha siteKey="siteKey" formControlName="captcha">
              </re-captcha> -->
          </div>
        </div>
      </div>

      <div
        class="ui box segment"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        id="section"
      >
        <div fxFlex (click)="goBack()" class="link">
          <i class="arrow left colored primary icon"></i>
        </div>
        <div>
          <button class="ui primary button" (click)="submit()">Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>
<sui-dimmer class="inverted page" [isDimmed]="pending">
  <div class="ui text loader">please wait...</div>
</sui-dimmer>
